/* istanbul ignore file */

export const WIDGET_SUB_NAVIGATION_TYPE = 'sub-nav';
